
const nullStorage = {
    getItem() {
        return null;
    },
    setItem(_key, _value) {
    },
    removeItem(_key) {
    },
    clear() {
    }
}

const storage = (typeof window === 'undefined') ? nullStorage : window.localStorage;

export default storage;
